import { api } from "@/api";
import { ManualUpdateMatchPayload } from "./manualUpdate";
import { CorrectionPreviewDto } from "./correctionPreview";

// Same payload and gates as the PATCH; nothing is persisted.
export const previewManualUpdateMatch = async (
  matchId: string,
  payload: ManualUpdateMatchPayload
): Promise<CorrectionPreviewDto> => {
  const res = await api.client.post(
    `/matches/${matchId}/manual-update/preview`,
    payload
  );
  return res.data;
};
